import { IconGift } from '@f_components/icons/IconGift';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const pulseColor = '#FF6B35';

const SPulsatingHighlightButton = styled(Button)<{ $pulseColor: string }>(({ $pulseColor }) => ({
    padding: '4px 10px',
    minWidth: 'auto',
    height: '28px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '12px',
    border: 'none',
    backgroundColor: $pulseColor,
    color: '#FFFFFF',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    boxShadow: `0 0 10px ${$pulseColor}66`,
    animation: 'pulse 2s ease-in-out infinite',
    '&:hover': {
        color: '#FFFFFF',
        backgroundColor: $pulseColor,
    },
    '@keyframes pulse': {
        '0%, 100%': {
            boxShadow: `0 0 20px ${$pulseColor}66`,
        },
        '50%': {
            boxShadow: `0 0 30px ${$pulseColor}99`,
        },
    },
    '@media (max-width: 1099px)': {
        display: 'none',
    },
}));

type ReferralButtonProps = {
    onClick: () => void;
};

export function ReferralButton({ onClick }: ReferralButtonProps) {
    const { t } = useTranslation();
    return (
        <SPulsatingHighlightButton $pulseColor={pulseColor} onClick={onClick} style={{ marginLeft: '80px' }}>
            <IconGift />
            {t('common.referral.button_text')}
        </SPulsatingHighlightButton>
    );
}
